import * as React from 'react';
import { buttonDriverFactory, ButtonDriver } from './Button.driver';
import { Button } from '.';
import {
  TPAComponentsWrapper,
  createRendererWithUniDriver,
} from '../../test/utils';
import { act } from '@testing-library/react';

describe('Button', () => {
  const render = createRendererWithUniDriver<ButtonDriver>(buttonDriverFactory);

  const baseProps = {};

  it('should render', async () => {
    const { driver } = render(<Button {...baseProps}>hello!</Button>);
    expect(await driver.exists()).toBe(true);
  });

  it('should render as button by default', async () => {
    const { driver } = render(<Button {...baseProps}>hello</Button>);
    expect((await driver.element()).nodeName.toLowerCase()).toEqual('button');
  });

  it('should render data-hook', async () => {
    const dataHook = 'data-hook';
    const { driver } = render(<Button data-hook={dataHook}>hello</Button>);
    expect(await driver.getAttribute('data-hook')).toEqual(dataHook);
  });

  it('should render children', async () => {
    const value = 'hello!';
    const { driver } = render(<Button {...baseProps}>{value}</Button>);
    expect(await driver.getButtonTextContent()).toEqual(value);
  });

  it('should set to fullWidth', async () => {
    const { driver } = render(<Button {...baseProps} fullWidth />);
    expect(await driver.isFullWidth()).toEqual(true);
  });

  it('should use mobile design', async () => {
    const dataHook = 'data-hook';
    const { driver } = render(
      TPAComponentsWrapper({ mobile: true })(<Button data-hook={dataHook} />),
      dataHook,
    );
    expect(await driver.isMobile()).toEqual(true);
  });

  it('should expose focus method using ref', async () => {
    const ref = React.createRef<HTMLButtonElement>();
    const { driver } = render(<Button {...baseProps} fullWidth ref={ref} />);
    await act(async () => ref.current.focus());
    expect(await driver.isFocus()).toBe(true);
  });

  it('should expose inner button element via ref chain', async () => {
    const ref = React.createRef<any>();
    const { driver } = render(<Button {...baseProps} fullWidth ref={ref} />);
    expect(await driver.element()).toEqual(
      ref.current.wrappedComponentRef.innerComponentRef,
    );
  });
});
